import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiReportPieChartComponent } from './fi-report-pie-chart.component';

@NgModule({
    imports: [CommonModule, FiChartModule],
    declarations: [FiReportPieChartComponent],
    exports: [FiReportPieChartComponent],
})
export class FiReportPieChartModule {}
